var card_content_default = {
  "content": "mEeGE",
  "textStart": "Hmptz",
  "contentText": "trruW",
  "subtitle": "TfnTY",
  "pricing": "_986vV",
  "titlePriceContainer": "Vjuxr",
  "textCenter": "ToJqT",
  "textEnd": "p3JtE",
  "titlePriceSideBySide": "LsY2Q",
  "titlePriceStacked": "_6KRDq",
  "title": "_3X-1V",
  "price": "NPJyj",
  "priceDiscounted": "e82nx",
  "priceOriginal": "USdhs",
  "priceStrikethrough": "g-CnP",
  "ribbon": "JeiTq",
  "button": "_0Rvc3",
  "button_disabled": "hw8ge",
  "buttonText": "_9yE1R",
  "framelessContent": "op8d8",
  "framelessImageTop": "K-Hzx",
  "framelessImageStart": "nOhfe",
  "framelessImageEnd": "_57kkw"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
